(function () {
  const POPULAR_SIZES = {
    mens: [
      '8',
      '8.5',
      '9',
      '9.5',
      '10',
      '10.5',
      '11',
      '11.5',
      '12',
      '12.5',
      '13',
      '13.5',
      '14'
    ],
    womens: [
      '5',
      '5.5',
      '6',
      '6.5',
      '7',
      '7.5',
      '8',
      '8.5',
      '9'
    ]
  };

  function normalizeSize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/½/g, '.5')
      .replace(/\s+/g, '');
  }

  function normalizeOptionName(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/:\s*$/, '')
      .replace(/\s+/g, ' ');
  }

  function isSizerOption(value) {
    return /not\s*sure|ring\s*sizer|need\s*(a\s*)?sizer|send\s*(me\s*)?(a\s*)?sizer/i.test(
      String(value || '')
    );
  }

  function getOptionName(wrapper) {
    const fieldset = wrapper.closest('fieldset.variant-option__wrapper');

    if (!fieldset) return '';

    const optionNameElement = fieldset.querySelector(
      '.variant-option__name > span:first-child'
    );

    return normalizeOptionName(optionNameElement?.textContent);
  }

  function getSizeProfile(wrapper) {
    const optionName = getOptionName(wrapper);

    /*
     * His-and-Hers sets:
     * "Her Size" always uses women's popular sizes.
     * "His Size" always uses men's popular sizes.
     */
    if (optionName === 'her size') {
      return 'womens';
    }

    if (optionName === 'his size') {
      return 'mens';
    }

    /*
     * Regular products:
     * Use the product's Size-Profile:Womens setting when present.
     */
    if (wrapper.dataset.sizeProfile === 'womens') {
      return 'womens';
    }

    return 'mens';
  }

  function initializeSizePills(wrapper) {
    if (
      wrapper.dataset.sizeOption !== 'true' ||
      wrapper.dataset.dynamicSizePillsInitialized === 'true'
    ) {
      return;
    }

    wrapper.dataset.dynamicSizePillsInitialized = 'true';

    const profile = getSizeProfile(wrapper);
    const popularSizes = POPULAR_SIZES[profile];

    const inputs = Array.from(
      wrapper.querySelectorAll(
        ':scope > input.variant-option[data-type="buttons"]'
      )
    );

    if (!inputs.length) {
      wrapper.classList.add('dynamic-size-pills--ready');
      return;
    }

    const sizeItems = inputs
      .map((input) => {
        const label = wrapper.querySelector(
          `label[for="${CSS.escape(input.id)}"]`
        );

        if (!label) return null;

        const value =
          input.dataset.value ||
          input.value ||
          label.dataset.optionValue ||
          label.textContent;

        return {
          input,
          label,
          value: String(value || '').trim(),
          normalizedValue: normalizeSize(value),
          isSizer: isSizerOption(value)
        };
      })
      .filter(Boolean);

    const sizerItem = sizeItems.find((item) => item.isSizer);

    function moveItemToEnd(item) {
      if (!item) return;

      wrapper.appendChild(item.input);
      wrapper.appendChild(item.label);
    }

    function isItemSelected(item) {
      return (
        item.input.classList.contains('selected') ||
        item.input.checked === true ||
        item.input.getAttribute('aria-selected') === 'true'
      );
    }

    /* Keep the sizer first in Shopify, but show its pill last visually. */
    moveItemToEnd(sizerItem);

    const rowBreak = document.createElement('span');
    rowBreak.className = 'dynamic-size-pills__row-break';

    const toggleButton = document.createElement('button');
    toggleButton.type = 'button';
    toggleButton.className = 'dynamic-size-pills__toggle';
    toggleButton.setAttribute('aria-expanded', 'false');

    let expanded = false;

    function updatePills() {
      let hiddenCount = 0;

      sizeItems.forEach((item) => {
        const isPopular = popularSizes.includes(item.normalizedValue);
        const isSelected = isItemSelected(item);

        const shouldShow =
          expanded || item.isSizer || isPopular || isSelected;

        item.label.style.display = shouldShow ? '' : 'none';

        if (!shouldShow && !item.isSizer) {
          hiddenCount += 1;
        }
      });

      moveItemToEnd(sizerItem);

      wrapper.appendChild(rowBreak);
      wrapper.appendChild(toggleButton);

      if (expanded) {
        toggleButton.textContent = 'Show fewer ▴';
        toggleButton.hidden = false;
      } else if (hiddenCount > 0) {
        toggleButton.textContent = `Show ${hiddenCount} more ${hiddenCount === 1 ? 'size' : 'sizes'} ▾`;
        toggleButton.hidden = false;
      } else {
        toggleButton.hidden = true;
      }

      toggleButton.setAttribute(
        'aria-expanded',
        String(expanded)
      );
    }

    toggleButton.addEventListener('click', function () {
      expanded = !expanded;
      updatePills();
    });

    wrapper.addEventListener('click', function (event) {
      const clickedOption = event.target.closest('.variant-option');

      if (!clickedOption || !wrapper.contains(clickedOption)) return;

      requestAnimationFrame(updatePills);
    });

    updatePills();
    wrapper.classList.add('dynamic-size-pills--ready');
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(
        '.variant-picker__product-option[data-size-option="true"]'
      )
      .forEach(initializeSizePills);
  }

  initializeAll();

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches?.(
            '.variant-picker__product-option[data-size-option="true"]'
          )
        ) {
          initializeSizePills(node);
        }

        initializeAll(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();